var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticStyle: { "margin-top": "20px" },
    },
    [
      _c(
        "el-tabs",
        { attrs: { "tab-position": "left" } },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "极光推送基础配置" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "10px 10px 10px 20px",
                    "line-height": "26px",
                    color: "#F59A23",
                    background: "#D9EDF7",
                  },
                },
                [
                  _vm._v(
                    "\n        1.“安卓 AppKey、iOS AppKey、 Master Secret” 是极光推送服务的关键参数，同时用于本系统的 【一键登录】 功能。点击查看"
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "5px",
                        color: "blue",
                        "text-decoration": "underline",
                        cursor: "pointer",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.jump(
                            "https://www.yuque.com/weixu-spa2e/pe5gxx/sq0mrgyzm1z2z7u2"
                          )
                        },
                      },
                    },
                    [_vm._v("推送具体注册和配置教程>>")]
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        2.这三个参数配置后 ，需重新打包 App 才能生效，请确保填写准确无误，填写后请勿随意修改。"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        3.下方“安卓推送/iOS推送”开关可实时控制对应平台的推送状态（建议开启）\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("pushConfig", {
                attrs: { "jguang-base-config": _vm.jguangBaseConfig },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "华为推送参数配置" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "10px 10px 10px 20px",
                    "line-height": "26px",
                    color: "#F59A23",
                    background: "#D9EDF7",
                    display: "flex",
                    "align-items": "center",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "50px", "margin-right": "10px" },
                    attrs: { src: require("../../../assets/huawei.png") },
                  }),
                  _vm._v(
                    "\n        注意：1.参数修改后，需重新打包才可生效！  2.应用上架华为后，打开华为推送后台获取以下配置\n        "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "blue",
                        "text-decoration": "underline",
                        cursor: "pointer",
                        "margin-left": "10px",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.jump(
                            "https://developer.huawei.com/consumer/cn/console/overview"
                          )
                        },
                      },
                    },
                    [_vm._v("点击跳转>>")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("pushHuaWeiConfig", {
                attrs: { "huawei-config": _vm.huaweiConfig },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "oppo推送参数配置" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "10px 10px 10px 20px",
                    "line-height": "26px",
                    color: "#F59A23",
                    background: "#D9EDF7",
                    display: "flex",
                    "align-items": "center",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "50px", "margin-right": "10px" },
                    attrs: { src: require("../../../assets/oppo.png") },
                  }),
                  _vm._v(
                    "\n        注意：1.参数修改后，需重新打包才可生效！  2.应用上架oppo后，打开oppo推送后台获取以下配置\n        "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "blue",
                        "text-decoration": "underline",
                        cursor: "pointer",
                        "margin-left": "10px",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.jump(
                            "https://open.oppomobile.com/product/page?page_name=push"
                          )
                        },
                      },
                    },
                    [_vm._v("点击跳转>>")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("pushOppoConfig", {
                attrs: { "oppo-config": _vm.oppoConfig },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "小米推送参数配置" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "10px 10px 10px 20px",
                    "line-height": "26px",
                    color: "#F59A23",
                    background: "#D9EDF7",
                    display: "flex",
                    "align-items": "center",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "50px", "margin-right": "10px" },
                    attrs: { src: require("../../../assets/xiaomi.png") },
                  }),
                  _vm._v(
                    "\n        注意：1.参数修改后，需重新打包才可生效！  2.应用上架小米后，打开小米推送后台获取以下配置\n        "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "blue",
                        "text-decoration": "underline",
                        cursor: "pointer",
                        "margin-left": "10px",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.jump(
                            "https://admin.xmpush.xiaomi.com/zh_CN/app/nav?version"
                          )
                        },
                      },
                    },
                    [_vm._v("点击跳转>>")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("pushXiaoMiConfig", {
                attrs: { "xiaomi-config": _vm.xiaomiConfig },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "vivo推送参数配置" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "10px 10px 10px 20px",
                    "line-height": "26px",
                    color: "#F59A23",
                    background: "#D9EDF7",
                    display: "flex",
                    "align-items": "center",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "50px", "margin-right": "10px" },
                    attrs: { src: require("../../../assets/vivo.png") },
                  }),
                  _vm._v(
                    "\n        注意：1.参数修改后，需重新打包才可生效！  2.应用上架vivo后，打开vivo推送后台获取以下配置\n        "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "blue",
                        "text-decoration": "underline",
                        cursor: "pointer",
                        "margin-left": "10px",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.jump(
                            "https://vpush.vivo.com.cn/#/homePage/appDetail"
                          )
                        },
                      },
                    },
                    [_vm._v("点击跳转>>")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("pushVivoConfig", {
                attrs: { "vivo-config": _vm.vivoConfig },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "荣耀推送参数配置" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    padding: "10px 10px 10px 20px",
                    "line-height": "26px",
                    color: "#F59A23",
                    background: "#D9EDF7",
                    display: "flex",
                    "align-items": "center",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "50px", "margin-right": "10px" },
                    attrs: { src: require("../../../assets/honor.png") },
                  }),
                  _vm._v(
                    "\n        注意：1.参数修改后，需重新打包才可生效！  2.应用上架荣耀后，打开荣耀推送后台获取以下配置\n        "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "blue",
                        "text-decoration": "underline",
                        cursor: "pointer",
                        "margin-left": "10px",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.jump("https://developer.honor.com/cn/")
                        },
                      },
                    },
                    [_vm._v("点击跳转>>")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("pushHonorConfig", {
                attrs: { "honor-config": _vm.honorConfig },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }